import { initFederation } from '@angular-architects/native-federation';

// Manifest is imported (not fetched) so the per-env remote URL is baked in at
// build time via fileReplacements (see apps/kodyuniverse/project.json esbuild
// configs). Default file = local (localhost:4201); development/staging/production
// configs swap in the deployed my.{dev,staging,}.kodypay.com URLs.
import federationManifest from './assets/federation.manifest.json';

initFederation(federationManifest)
  .catch((err) => console.error(err))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));
